export default {
  HEADER_HEIGHT:  80,
  SIDEBAR_WIDTH: 424,
  CHECK_CENTERED_OPTION_VIEW_HEIGHT: 100
}